import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import TasBenefitHistory from 'tio-employee/components/tas/benefit-history';
import type { BenefitHistoryModel } from 'tio-employee/routes/authenticated/tas/benefit-history';

interface BenefitHistoryRouteSignature {
  Args: {
    model: BenefitHistoryModel;
  };
}

const tmpl: TOC<BenefitHistoryRouteSignature> = <template>
  <VStack>
    <PageHeader @a11yTitle={{t "tas.benefit_history.title"}} @sticky={{false}} />
    <TasBenefitHistory @model={{@model}} />
  </VStack>
</template>;

export default tmpl;
